import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { CommonFunctions } from '@shared/common-functions';
import { EMAIL_VALIDATION_PATTERN, itemsPerPageList, NAME_VALIDATION_PATTERN, USER_ROLES, USER_TYPE, UserRole } from '@shared/constant/shared.constant';
import { ItemPerPage } from '@core/models/file-response.model';
import { CompanyService, BreadcrumbItem } from '@shared/services/company.service';
import { autoUnsubWith, Utility } from '@shared/services/utility.abstract';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { DriverList } from '@core/models/booking.model';
import { SuperAdminService } from '@core/services/super-admin.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { DriverService } from '../driver/services/driver.service';
import { EncryptionStorageService } from '@core/services/encryption-storage.service';

@Component({
  selector: 'app-custom-credit-list',
  templateUrl: './custom-credit-list.component.html',
  styleUrls: ['./custom-credit-list.component.scss']
})
export class CustomCreditListComponent implements OnInit{
  readonly destroyRef = inject(DestroyRef);
  creditList: any;
  itemsPerPage: number = 10;
  items: any;
  totalUserRecord: number;
  currentSkip: number = 0;
  currentPageUpcoming: number = 1;
  CustomItemPerPageBy: ItemPerPage[] = itemsPerPageList;
  dummy: string = '../../../../assets/images/dummy-img.png';
  excelFile: DriverList[] = [];
  userListRequest: any;
  role: string = '';
  roleRoute: string = '';
  searchStatus: any;
  selectStatus: { name: string; value: number }[] = [];
  userRoles = USER_ROLES;
  ref: DynamicDialogRef | undefined;
  userTypeDropdown = [];
  creditListForm: FormGroup;
  hideAdvanceFilter: boolean = false;
  companyList : any[] = [];
  showAsterisk: boolean;
  selectedCompanies: any[] = [];
  companyListWithAll: any[];
  userType = USER_TYPE;

  constructor(
    private readonly superAdminService: SuperAdminService,
    private readonly companyService: CompanyService,
    private readonly fb : FormBuilder,
    private readonly router: Router,
    private readonly driverService: DriverService,
    private readonly encryptStorage: EncryptionStorageService
  ) {
    this.role = this.encryptStorage.getItem('roleName');
    this.roleRoute = CommonFunctions.routeToBookingDetail(this.role);
  }

  ngOnInit() {
    this.initialiseCreditListForm();
    this.getCompanyList();
    this.selectStatus = [
      { name: 'All', value: null },
      { name: 'Super Admin', value: 3 },
      { name: 'Parking Admin', value: 2 },
      { name: 'Parking Manager', value:1 },
    ];
    this.userTypeDropdown = [
      { name: 'All User', value: UserRole.Both },
      { name: 'Parker', value: UserRole.Parker },
      { name: 'Group Operator', value: UserRole.GroupOperator },
    ]
  
    const breadcrumbObj: BreadcrumbItem[] = [
      {
        title: 'Custom Credit List',
      },
    ];
    this.companyService.setAdminHeaders('0', breadcrumbObj);
    this.goToTop();
    this.superAdminService.setShowInput(false);

  }

   initialiseCreditListForm(): void {
      this.creditListForm = this.fb.group({
        name: ['', [ Validators.pattern(NAME_VALIDATION_PATTERN), Validators.minLength(3), Validators.maxLength(50)]],
        email: ['', [Validators.pattern(EMAIL_VALIDATION_PATTERN)]],
        number: ['', [ Validators.minLength(3), Validators.maxLength(50)]],
        userType: [null],
        givenBy: [null],
        companies:[[]],
      });
    }
    exportData() {
      this.userListRequest = {
        name: this.creditListForm.value.name || '',
        mobileNumber: this.creditListForm.value.number || '',
        email: this.creditListForm.value.email || '',
        creditGivenBy: this.creditListForm.value.givenBy || null,
        usertype: this.creditListForm.value.userType ,
        pageNumber: 0,
        pageSize: 0,
        companyId: this.isSuperAdmin()
        ? this.creditListForm.value.companies.map(company => company.id).filter(id => id !== null && id !== undefined)
        : [],
        timeZone: Utility.getLocalTimeZone()
      };
      this.getCreditListExcelSheet(this.userListRequest);
    }

  isSuperAdmin(): boolean {
    return this.role === this.userRoles.SUPER_ADMIN;
  }

  toggleHideAdvanceFilter() {
    this.hideAdvanceFilter = !this.hideAdvanceFilter;;
  }

  getCompanyList() {
    
    const searchPayload = {
      timeZone: ''
    };
    this.superAdminService.getCompanyListForDropdown(searchPayload)
    .pipe(autoUnsubWith(this.destroyRef))
    .subscribe({
      next: (response: any) => {
        this.goToTop();
        this.companyList = response;
        const selectedCompany = history.state?.selectedCompany;
        const selectedIds = Array.isArray(selectedCompany) ? selectedCompany : [selectedCompany];
        const validSelectedLots = this.companyList.filter(lot => selectedIds.includes(lot.id));
        this.creditListForm.controls['companies'].setValue(
          validSelectedLots.length ? validSelectedLots : [...this.companyList]
        );
        this.getUserListCreatedBySuperAdmin('firsttime');
      },
      error: () => {
        this.companyList = [];
        
      }
    });
  }

onSelectionChange(event) {
    this.showAsterisk = false;
    const selectedValues = event.value as string[];
    if (selectedValues.includes('all')) {
      if (selectedValues?.length === this.companyListWithAll?.length) {
        return;
      }
      this.selectedCompanies = this.companyList.map(lot => lot.id);
    } else {
      const index = this.selectedCompanies.indexOf('all');
      if (index !== -1) {
        this.selectedCompanies.splice(index, 1);
      }
      this.selectedCompanies = selectedValues;
    }
  }

getCreditListExcelSheet(userRequest) {
      this.superAdminService.customCreditList(userRequest)
      .pipe(autoUnsubWith(this.destroyRef))
      .subscribe({
        next: (response : any) => {
          this.excelFile = response.data?.spOutput
          
            const headers = [
            { header: 'S. No.', key: 'index', formatter: (value) => value + 1 },
            { key: 'driverName', header: 'Name', formatter: (value) => value || '-' },
            { key: 'email', header: 'Email', formatter: (value) => value ? value : '-' },
            {
              key: 'phoneNumber',
              header: 'Mobile Number',
              formatter: (_, row) => (row.countryCode && row.phoneNumber ? `${row.countryCode} ${row.phoneNumber}` : '-')
            },
            { key: 'userType', header: 'User Type', formatter: (value) => value ? value : '-' },
            { key: 'companyName', header: 'Company Name', formatter: (value) => value ? value : '-' },
              { 
                key: 'creditGivenBy', 
                header: 'Credit Given By', 
              formatter: (_, row) => {
              const role = row.creditGivenByRole ? row.creditGivenByRole : '-';
              const name = row.creditGivenByName ? row.creditGivenByName : '-';
              return `${role} / ${name}`;
              }
            },
            { key: 'creditGivenDate', header: 'Credit Given Date', formatter: (value) => value ? new Date(value) : '-' },
            { key: 'creditAmount', header: 'Credits', formatter: (value) => value ? value : '-' },
            { key: 'reason', header: 'Reason', formatter: (value) => value ? value : '-'  },
            ];
          const dataWithIndex = this.excelFile.map((item, index) => ({
            ...item,
            index,
          }));
          return CommonFunctions.exportToExcel(dataWithIndex, headers, 'Custom Credit List Export_');
        }
      });
    }
    
  getUserListCreatedBySuperAdmin(changeAction) {
    if (this.isSuperAdmin() && this.creditListForm.value?.companies?.length === 0) {
      this.showAsterisk = true;
      return;
    } 
    
    if (changeAction === 'reset') {
      this.userListRequest = {
        name: '',
        mobileNumber: '',
        email: '',
        status: null,
        pageNumber: this.currentPageUpcoming,
        pageSize: this.itemsPerPage,
        usertype: UserRole.Both,
        companyId: this.isSuperAdmin()
        ? this.creditListForm.value.companies.map(company => company.id).filter(id => id !== null && id !== undefined)
        : [],
        timeZone: Utility.getLocalTimeZone(),
      };
    } else {
      if (changeAction === 'search') {
        this.userListRequest = {
          name: this.creditListForm.value.name || '',
          mobileNumber: this.creditListForm.value.number || '',
          email: this.creditListForm.value.email || '',
          creditGivenBy: this.creditListForm.value.givenBy || null,
          usertype: this.creditListForm.value.userType ,
          pageNumber: 1,
          pageSize: this.itemsPerPage,
          companyId: this.isSuperAdmin()
          ? this.creditListForm.value.companies.map(company => company.id).filter(id => id !== null && id !== undefined)
          : [],
          timeZone: Utility.getLocalTimeZone()
        };
      } else {
        this.userListRequest = {
          name: this.creditListForm.value.name || '',
          mobileNumber: this.creditListForm.value.number || '',
          email: this.creditListForm.value.email || '',
          creditGivenBy: this.creditListForm.value.givenBy || null,
          usertype: this.creditListForm.value.userType,
          pageNumber: this.currentPageUpcoming,
          pageSize: this.itemsPerPage,
          companyId: this.isSuperAdmin()
            ? this.creditListForm.value.companies.map(company => company.id).filter(id => id !== null && id !== undefined)
            : [],
          timeZone: Utility.getLocalTimeZone(),
        };
      }
    }
    this.getCreditList(this.userListRequest, changeAction);
  }

  getCreditList(userRequest, changeAction?: string) {
    this.superAdminService.customCreditList(userRequest)
    .pipe(autoUnsubWith(this.destroyRef))
    .subscribe({
      next: (response: any) => {
        if (changeAction === 'search') {
          this.currentSkip = 0;
          CommonFunctions.scrollTopRow('top');
        }
        this.totalUserRecord = response.data.totalRecords;
        this.creditList = response.data?.spOutput;
        this.excelFile = this.creditList;
        
      },
      error: (_error) => {
        this.currentSkip = 0;
        this.creditList = [];
      },
    });
  }

  onPageChange(event: any) {
    this.currentSkip = event.first;
    this.currentPageUpcoming = event.page + 1;
    CommonFunctions.scrollTopRow('top');
    this.getUserListCreatedBySuperAdmin('pageChange');
  }

  onDropdownChange(event: any, change: string) {
    this.itemsPerPage = event.value;
    this.currentSkip = 1;
    this.currentPageUpcoming = 1;
    CommonFunctions.scrollTopRow('top');
    this.getUserListCreatedBySuperAdmin(change);
  }

  getFlagClass(iso: string): string {
    const lowerCaseIso = iso?.toLowerCase();
    return `fi fi-${lowerCaseIso}`;
  }

  resetFilter() {
    this.creditListForm.reset();
    this.showAsterisk = false;  
    this.getCompanyList();
    this.getUserListCreatedBySuperAdmin('reset');
  }

  goToTop() {
    window.scrollTo({
      behavior: 'smooth',
      top: 0,
    });
  }

  onlyNumber(event: any) {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      event.preventDefault();
    }
  }

  goToCrmPage(rowData: any) {
    const isGroupOperator = rowData?.userType === this.userType.GROUP_OPERATOR;

    const page = isGroupOperator ? 'group-operator-info' : 'driver-info';
    const queryParam = isGroupOperator ? 'Id' : 'id';

    CommonFunctions.navigateToCRM(
      this.roleRoute,
      rowData.id,
      this.router,
      this.driverService,
      page,
      queryParam,
      '0'
    );
  }
}
